package com.appsyde.shared.modules.ai.domain.usecase

import com.appsyde.shared.modules.ai.domain.model.AiExtractV2
import com.appsyde.shared.modules.ai.domain.repository.AiRepositoryV2
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.jsonObject


class GenerateAiExtractUseCase(
    private val repo: AiRepositoryV2,
) {
    private val json = Json { ignoreUnknownKeys = true }

    suspend operator fun invoke(messageId: String, force: Boolean = false): GenerateAiExtractResult {
        val raw = repo.generateExtractJson(messageId = messageId, force = force)

        // Logs utiles (pas trop verbeux)
        val preview = raw.replace("\n", " ").take(220)
        val keys = runCatching {
            json.parseToJsonElement(raw).jsonObject.keys.sorted().joinToString(",")
        }.getOrNull()

        println("[AI] generate bytes=${raw.length} keys=$keys preview=$preview")

        val extract = runCatching {
            json.decodeFromString(AiExtractV2.serializer(), raw)
        }.getOrElse { err ->
            // fallback "empty" mais on garde raw pour debug UI
            println("[AI] parse failed: ${err.message}")
            AiExtractV2()
        }

        return GenerateAiExtractResult(
            rawJson = raw,
            extract = extract,
            draft = extract.response?.trim()?.takeIf { it.isNotBlank() }
        )
    }
}

data class GenerateAiExtractResult(
    val rawJson: String,
    val extract: AiExtractV2,
    val draft: String?
)